import { createI18n } from 'vue-i18n'
import it from './locales/it.json'
import en from './locales/en.json'
import es from './locales/es.json'

const messages = {
    it,
    en,
    es
}

const i18n = createI18n({
    legacy: false, // Set to false to use Composition API
    locale: 'it', // set locale
    fallbackLocale: 'en', // set fallback locale
    messages, // set locale messages
})

export default i18n
